import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Kenyachem · Your Trusted Chemical Supplier</p>
        <h1>Welcome to Kenyachem</h1>
        <p className="lede">
          Discover high-quality chemical solutions tailored for your needs. At Kenyachem, we prioritize safety, efficiency, and sustainability in every product we offer.
        </p>
        <div className="cta-row">
          <a href="/products" target="_blank">
            Explore Our Products
          </a>
          <a href="/about" target="_blank" className="secondary">
            Learn More About Us
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Quality You Can Trust</h2>
          <p>
            Our products undergo rigorous testing to ensure they meet the highest industry standards, providing you with reliable solutions for your projects.
          </p>
        </article>
        <article>
          <h2>Customized Solutions</h2>
          <p>
            We work closely with our clients to develop tailored chemical solutions that meet specific requirements, ensuring optimal performance and satisfaction.
          </p>
        </article>
        <article>
          <h2>Commitment to Sustainability</h2>
          <p>
            At Kenyachem, we are dedicated to environmentally friendly practices, offering products that minimize impact while maximizing efficiency.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;